import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "react-router-dom";

const styles = {
  MainDiv: {
    width: "100vw",
    height: "100%",
    margin: "auto",
    backgroundColor: "rgb(249, 249, 249)",
  },
  card: {
    height: "97px",
    width: "350px",
    border: "none",
    margin: "40px",
    borderRadius: "4.361px",
    boxShadow:
      "0px 0px 7.63194465637207px 1.0902777910232544px rgba(0, 0, 0, 0.20)",
  },
  subDiv: {
    display: "flex",
    justifyContent: "space-evenly",
    alignItems: "center",
    height: "100%",
  },
  ImgDiv: { borderRight: "solid black 3px", marginLeft: "25px" },
  Img: { marginRight: "20px", height: "50px", width: "50px" },
  TextDiv: {
    textAlign: "left",
    marginRight: "30px",
    color: "navy",
    flex: 1,
    marginLeft: "25px",
  },
  MainFont: { fontWeight: "bold" },
};

const cardData = [
  {
    imageSrc: require("../Assets/PVBU.png"),
    title: "TATA Motors Passenger Vehicles Ltd",
    subtitle: "Pune, Chikhali",
    linkTo: "/selectmodule",
  },
  {
    imageSrc: require("../Assets/CVBU.png"),
    title: "TATA Motors CVBU",
    subtitle: "Pune",
    linkTo: "/selectmodule",
  },
  {
    imageSrc: require("../Assets/PVBU.png"),
    title: "TATA Motors PVBU",
    subtitle: "Ranjangaon",
    linkTo: "/homepage",
  },
  {
    imageSrc: require("../Assets/PVBU.png"),
    title: "TATA Motors Passenger Vehicles Ltd",
    subtitle: "Sanand-01",
    linkTo: "/homepage",
  },
  {
    imageSrc: require("../Assets/PVBU.png"),
    title: "TATA Passenger Electric Mobility Ltd",
    subtitle: "Sanand-02",
    linkTo: "/homepage",
  },
  {
    imageSrc: require("../Assets/CVBU.png"),
    title: "TATA Motors CVBU",
    subtitle: "Jamshedpur",
    linkTo: "/homepage",
  },
  {
    imageSrc: require("../Assets/CVBU.png"),
    title: "TATA Motors CVBU",
    subtitle: "Lucknow",
    linkTo: "/homepage",
  },
  {
    imageSrc: require("../Assets/CVBU.png"),
    title: "TATA Motors CVBU",
    subtitle: "Pantnagar",
    linkTo: "/homepage",
  },
  {
    imageSrc: require("../Assets/CVBU.png"),
    title: "TATA Motors CVBU",
    subtitle: "Dharwad",
    linkTo: "/homepage",
  },
  {
    imageSrc: require("../Assets/CVBU.png"),
    title: "TATA Motors CVBU",
    subtitle: "Uttarakhand",
    linkTo: "/homepage",
  },
];

const HomePage = () => {
  return (
    <div style={styles.MainDiv}>
      <Container style={{ paddingTop: "20px", paddingBottom: "20px" }}>
        <Row>
          {cardData.map((card, index) => (
            <Col key={index} sm={12} xs={12} md={12} lg={6} xl={4} xxl={4}>
              <Link to={card.linkTo}>
                <div className="card" style={styles.card}>
                  <div style={styles.subDiv}>
                    <div style={styles.ImgDiv}>
                      <img
                        src={card.imageSrc}
                        style={styles.Img}
                        className="d-inline-block align-top"
                        alt="logo"
                      />
                    </div>
                    <div style={styles.TextDiv}>
                      <div style={styles.MainFont}>{card.title}</div>
                      <div>{card.subtitle}</div>
                    </div>
                  </div>
                </div>
              </Link>
            </Col>
          ))}
        </Row>
      </Container>
    </div>
  );
};

export default HomePage;
